import { useRef } from "react";
import Form from "react-bootstrap/Form";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";

//Common
import { TextField, Chip } from "../common/VFX-UI";
import ActionBar from "../common/ActionBar/ActionBar";
import FormBackGround from "../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../common/Forms/FormHeader/FormHeader";

//App
import { EMPTY_GUID } from "../../utility/constants/constants";
import { AgencyFormProps } from "../../types/agency";

const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
});

const AgencyForm = (props: AgencyFormProps) => {
    const { status, initialVal, onClose, handleOnSubmit } = props;
    const formRef = useRef<FormikProps<any>>(null);

    const { id } = initialVal;
    const title = id === EMPTY_GUID ? "New Agency" : "Edit Agency";

    const saveInput = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    return (
        <FormBackGround>
            <FormHeader title={title} onClose={onClose} />
            <Formik
                onSubmit={handleOnSubmit}
                initialValues={initialVal}
                validationSchema={validationSchema}
                innerRef={formRef}
            >
                {({ values }) => (

                    <Form noValidate>
                        <div className="d-flex justify-content-end mb-3 me-3">
                            <Chip label={values.isActive ? "Active" : "Inactive"} />
                        </div>

                        <div className="mx-3">
                            <TextField
                                label="Name"
                                type="text"
                                name="name"
                                isRequired={true}
                            />
                            <TextField
                                label="Description"
                                type="text"
                                name="description"
                                isRequired={false}
                            />
                        </div>

                        <div className="mt-5">
                            <ActionBar
                                submitHandler={saveInput}
                                cancelHandler={onClose}
                                submitText="Submit"
                                cancelText="Cancel"
                                isLoading={status === "pending"}
                            ></ActionBar>
                        </div>
                    </Form>

                )}
            </Formik>
        </FormBackGround>
    );
};

export default AgencyForm;
